export default __webpack_public_path__ + "static/media/54_4_0.92fa859d.png";